import * as React from 'react';
import { useEffect, useState } from 'react';
import { isNumber } from "underscore";
import { Tooltip } from './Tooltip';

const PlusMinusInputWithDebounceRFQ = (props) => {
    const { force_default_quantity } = props;
    const { disable_validation_check } = props;
    const { QtyMult } = props;
    const { QtyMin } = props;
    const [tempQuantity, setTempQuantity] = useState(false);

    const setQuantityWithAction = async (action) => {
        async function fetchHere() {
            let QtyMultHere = QtyMult;
            let q = 0;
            if (action === 'minus') {
                q = tempQuantity - QtyMultHere
            }
            if (action === 'plus') {
                q = tempQuantity + QtyMultHere
            }
            if (q < 1) {
                q = 0;
            }
            if (q > 0) {
                await manageTempQuantity(q);
            }
        }

        fetchHere()
    };
    useEffect(() => {
        async function fetchHere() {
            if (force_default_quantity !== undefined) {
                setTempQuantity(force_default_quantity);
            }
        }
        fetchHere();
    }, [force_default_quantity]);
    const manageTempQuantity = (valueIn) => {
        valueIn = parseInt(valueIn);
        if (isNaN(valueIn)) {
            valueIn = 0;
        }
        setTempQuantity(valueIn);
        if (valueIn !== false) {
            if (props.onChange !== undefined) {
                let d = validateBeforeSendToMainCheckFailing(valueIn);
                if (disable_validation_check !== undefined && disable_validation_check === true) {
                    props.onChange(d, valueIn)
                    return;
                }

            }
        }
    }
    const validateBeforeSendToMainCheckFailing = (valueIn) => {
        if (QtyMin !== undefined && valueIn < QtyMin) {
            return "Please enter a quantity greater than the minimum required for quoting.";
        }
        if (QtyMult !== undefined && valueIn % QtyMult !== 0) {
            return "Invalid Quantity";
        }
        return "";
    };
    const minValueTooltip = () => {
        return 'Depending on the minimum value threshold for quoting, the minimum quantity will be altered.';
    }

    return (
        <>
            <div className="quantity w-auto clearfix ">
                <div className="quantity-picker">
                    <div className="bs5 input-group flex-nowrap border-0">
                        <span className="bs5 input-group-prepend flex-nowrap">
                            <button type="button"
                                onClick={async () => {
                                    await setQuantityWithAction('minus');
                                }}
                                className="bs5 btn btn-outline-secondary btn-number br-0">
                                <span className="fa quantity-picker-minus" />
                            </button>
                        </span>
                        <input type="text" className="form-control input-number bg-white"
                            placeholder={QtyMult !== undefined ? QtyMult : 0}
                            value={tempQuantity}
                            onChange={(e) => {
                                let n = parseInt(e.target.value);
                                if (!isNumber(n)) {
                                    n = false;
                                }
                                if (n !== false) {
                                    manageTempQuantity(n)
                                }
                            }}
                        />
                        <span className="bs5 input-group-append flex-nowrap">
                            <button type="button"
                                onClick={async () => {
                                    await setQuantityWithAction('plus');
                                }}
                                className="bs5 btn btn-outline-secondary btn-number bl-0">
                                <span className="fa quantity-picker-plus" />
                            </button>
                        </span>
                    </div>
                </div>
                <div className="text-start small-text light light-text collapse_minmax">
                    <Tooltip position={'right'}
                        opener={() => (<i className="fa fa-info-circle me-1 font-13" />)}
                        content={() => (minValueTooltip())}
                    />
                    <span className='min-mult-labal'>Min:</span>{QtyMin ? QtyMin : 0} &nbsp;
                    <span className='min-mult-labal'>Mult:</span>{QtyMult ? QtyMult : 0} &nbsp;
                </div>
                
            </div>
        </>
    );
}

export default PlusMinusInputWithDebounceRFQ;